import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const PublisherContainers = {
    getContainres(params, callback) {
        dispatch({
            type: AppConstants.CONTAINERS_SEARCH_START_LOADING
        });

        return api.searchContainres(params)
        .then(data => {
            dispatch({
                type  : AppConstants.CONTAINERS_SEARCH_SUCCESS,
                items : data.response || {}
            });

            callback && callback();
        })
        .catch(err => {
            handleError(err, () => {
                dispatch({
                    type: AppConstants.CONTAINERS_FAIL,
                    error: err
                });
            });
        });
    },

    getLocales(params) {
        return api.searchContainreLocales(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.CONTAINERS_LOCALES_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {});
            });
    }
};

export default PublisherContainers;
